import './style.scss';

import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { USER_TYPE } from '../../../../../../utils/common/constants';
import { UserFormModel } from '../../../../models';

type Props = {
  className?: string,
  values: UserFormModel,
  rtl?: boolean,
  step?: number,
  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void,
}

const AccountType: React.FC<Props> = ({ className, rtl, step, values, setFieldValue }) => {
  const { t } = useTranslation();
  const [typeState, setTypeState] = useState(values?.userType);

  useEffect(() => {
    setTypeState(values?.userType);
  }, [values?.userType])

  const changeUserType = (type: string) => {
    setFieldValue("userType", type);
    setTypeState(type);
  }

  const checkSelectUserType = (type: string) => {
    if (typeState == type) return 'active';
    return '';
  }

  return (
    <>
      <div className='box-step-1 mt-7'>
        <h1 className='title-user-type'>{t('USERS_PAGE.CONTENT_STEP.STEP1.TITLE')}</h1>
        <div className='role-select mt-6'>
          <div className={`role-select--item ${checkSelectUserType(USER_TYPE.ADMIN)}`} onClick={() => changeUserType(USER_TYPE.ADMIN)}>
            <div className="image">
              <img src='/assets/images/icons/admin.svg' />
            </div>
            <div className="text">
              <div className="name">{t('USERS_PAGE.CONTENT_STEP.STEP1.SUPERVISOR_TYPE_TITLE')}</div>
              <div className="desc">{t('USERS_PAGE.CONTENT_STEP.STEP1.ADMIN_TYPE_DESC')}</div>
            </div>
          </div>
          {/* <div className={`role-select--item ${checkSelectUserType(USER_TYPE.TECHNICIAN)}`} onClick={() => changeUserType(USER_TYPE.TECHNICIAN)}>
            <div className="image image-border">
              <svg width="18" height="21" viewBox="0 0 18 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15 0.16246H3C2.20435 0.16246 1.44129 0.480302 0.87868 1.04606C0.316071 1.61182 0 2.37916 0 3.17927V15.2465C0.00173951 15.8689 0.194879 16.4755 0.552938 16.9832C0.910998 17.4909 1.41645 17.8748 2 18.0823V19.2689C2 19.5356 2.10536 19.7914 2.29289 19.98C2.48043 20.1686 2.73478 20.2745 3 20.2745C3.26522 20.2745 3.51957 20.1686 3.70711 19.98C3.89464 19.7914 4 19.5356 4 19.2689V18.2633H14V19.2689C14 19.5356 14.1054 19.7914 14.2929 19.98C14.4804 20.1686 14.7348 20.2745 15 20.2745C15.2652 20.2745 15.5196 20.1686 15.7071 19.98C15.8946 19.7914 16 19.5356 16 19.2689V18.0823C16.5835 17.8748 17.089 17.4909 17.4471 16.9832C17.8051 16.4755 17.9983 15.8689 18 15.2465V3.17927C18 2.37916 17.6839 1.61182 17.1213 1.04606C16.5587 0.480302 15.7956 0.16246 15 0.16246ZM2 6.19607H8V10.2185H2V6.19607ZM16 15.2465C16 15.5132 15.8946 15.769 15.7071 15.9576C15.5196 16.1461 15.2652 16.2521 15 16.2521H3C2.73478 16.2521 2.48043 16.1461 2.29289 15.9576C2.10536 15.769 2 15.5132 2 15.2465V12.2297H16V15.2465ZM16 10.2185H10V6.19607H16V10.2185ZM16 4.18487H2V3.17927C2 2.91256 2.10536 2.65679 2.29289 2.4682C2.48043 2.27961 2.73478 2.17366 3 2.17366H15C15.2652 2.17366 15.5196 2.27961 15.7071 2.4682C15.8946 2.65679 16 2.91256 16 3.17927V4.18487ZM12.62 15.166C12.7402 15.2176 12.8693 15.2449 13 15.2465C13.2652 15.2465 13.5196 15.1405 13.7071 14.952C13.8946 14.7634 14 14.5076 14 14.2409C14.0049 14.1739 14.0049 14.1067 14 14.0398C13.9891 13.9768 13.9688 13.9158 13.94 13.8588C13.9181 13.7947 13.8878 13.7338 13.85 13.6777C13.8131 13.6251 13.773 13.5747 13.73 13.5269L13.58 13.4062C13.5243 13.3682 13.4637 13.3377 13.4 13.3157C13.3383 13.2777 13.2707 13.2505 13.2 13.2353C13.0378 13.2012 12.8698 13.2082 12.7109 13.2555C12.5521 13.3029 12.4074 13.3893 12.29 13.5068C12.247 13.5546 12.2069 13.605 12.17 13.6576C12.1322 13.7137 12.1019 13.7746 12.08 13.8386C12.0512 13.8956 12.0309 13.9567 12.02 14.0197C12.0151 14.0866 12.0151 14.1538 12.02 14.2208C12.0211 14.4846 12.1253 14.7374 12.31 14.9247C12.3965 15.0249 12.5018 15.1069 12.62 15.166ZM4.62 15.166C4.74022 15.2176 4.86932 15.2449 5 15.2465C5.26522 15.2465 5.51957 15.1405 5.70711 14.952C5.89464 14.7634 6 14.5076 6 14.2409C6.00491 14.1739 6.00491 14.1067 6 14.0398C5.98905 13.9768 5.96883 13.9158 5.94 13.8588C5.91811 13.7947 5.88785 13.7338 5.85 13.6777C5.81308 13.6251 5.77301 13.5747 5.73 13.5269L5.58 13.4062L5.4 13.3157L5.2 13.2353C5.03782 13.2012 4.86976 13.2082 4.71092 13.2555C4.55208 13.3029 4.40744 13.3893 4.29 13.5068C4.24699 13.5546 4.20692 13.605 4.17 13.6576C4.13215 13.7137 4.10189 13.7746 4.08 13.8386C4.05117 13.8956 4.03095 13.9567 4.02 14.0197C4.01509 14.0866 4.01509 14.1538 4.02 14.2208C4.0211 14.4846 4.12526 14.7374 4.31 14.9247C4.39649 15.0249 4.50184 15.1069 4.62 15.166Z" fill="#FFC20F" />
              </svg>
            </div>
            <div className="text">
              <div className="name">{t('USERS_PAGE.CONTENT_STEP.STEP1.BUS_TYPE_TITLE')}</div>
              <div className="desc">{t('USERS_PAGE.CONTENT_STEP.STEP1.BUS_TYPE_DESC')}</div>
            </div>
          </div> */}
          <div className={`role-select--item ${checkSelectUserType(USER_TYPE.TECHNICIAN)}`} onClick={() => changeUserType(USER_TYPE.TECHNICIAN)}>
            <div className="image image-border">
              <img src='/assets/images/icons/bus-driver.svg' />
            </div>
            <div className="text">
              <div className="name">{t('USERS_PAGE.CONTENT_STEP.STEP1.BUS_DRIVER_TYPE_TITLE')}</div>
              <div className="desc">{t('USERS_PAGE.CONTENT_STEP.STEP1.BUS_DRIVER_TYPE_DESC')}</div>
            </div>
          </div>
          <div className={`role-select--item ${checkSelectUserType(USER_TYPE.WORKER)}`} onClick={() => changeUserType(USER_TYPE.WORKER)}>
            <div className="image image-border">
              <img src='/assets/images/icons/worker.svg' />
            </div>
            <div className="text">
              <div className="name">{t('USERS_PAGE.CONTENT_STEP.STEP1.WORKER_TYPE_TITLE')}</div>
              <div className="desc">{t('USERS_PAGE.CONTENT_STEP.STEP1.WORKER_TYPE_DESC')}</div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default AccountType;